import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-current-trip-dashboard',
  templateUrl: './mcommerce-current-trip-dashboard.component.html',
  styleUrls: ['./mcommerce-current-trip-dashboard.component.scss']
})
export class McommerceCurrentTripDashboardComponent implements OnInit {

  trips;

  constructor() {
    this.trips = [ { id: 1, status: 'expired', name: 'Fernando García', products: '43', price: '17,45 €', store: 'mShop Market', time: '16:03', comments: 'Lorem ipsum dolor sit amet consecteur adispicing elit', device: ['Android', 'Oreo 8.0'] },
        { id: 2, status: 'cancelled', name: 'Javier Suárez', products: '1', price: '17,45 €', store: 'mShop Market', time: '16:03', comments: 'Lorem ipsum dolor sit amet consecteur adispicing elit', device: ['Android', 'Oreo 8.0'] },
        { id: 3, status: 'delivered', name: 'Huan Froilán', products: '16', price: '17,45 €', store: 'mShop Market', time: '16:03', comments: 'Lorem ipsum dolor sit amet consecteur adispicing elit', device: ['Android', 'Oreo 8.0'] },
        { id: 4, status: 'audit', name: 'John DOE', products: '31', price: '17,45 €', store: 'mShop Market', time: '16:03', comments: 'Lorem ipsum dolor sit amet consecteur adispicing elit', device: ['Android', 'Oreo 8.0'] } ];
  }

  ngOnInit() {
  }

}
